module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_snr-f0309cfe0fd8caef5374e4c2fad69256.png";